<template>
  <div>
    <header>
      <head-top></head-top>
      <el-carousel :interval="3000" arrow="always">
        <el-carousel-item>
          <div class="top">
            <div class="wrapper">
              <div class="header-top">
                <div class="left">
                  <img
                    src="./../../assets/resource/home/logo.png"
                    alt=""
                    class="logo"
                  />
                </div>
                <div class="right">
                  <img
                    src="./../../assets/resource/home/bbc.gif"
                    alt=""
                    class="tvFrame"
                  />
                </div>
                <div class="typeWrapper">
                  <div class="type" ref="headType"></div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>

        <!-- <el-carousel-item>
          <div class="banner2">
            <a target="_blank" href="http://s.noc.net.cn/home/zs?c=SCTZ">
              <div class="common">
                <img
                  class="newBanner"
                  src="./../../assets/resource/home/banner/noc-2.png"
                />
              </div>
            </a>
          </div>
        </el-carousel-item> -->

        <el-carousel-item>
          <div class="banner2">
            <a
              href="https://paat.ceracu.org.cn/#/home"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="common">
                <img
                  class="newBanner"
                  src="./../../assets/resource/home/banner/paat1920.jpg"
                />
                <img
                  class="newlogo"
                  src="./../../assets/resource/home/banner/paatlogo.jpg"
                />
              </div>
            </a>
          </div>
        </el-carousel-item>

        <el-carousel-item>
          <div class="banner2">
            <a
              href="https://www.istemedu.com/jskx"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="common">
                <img
                  class="newBanner"
                  src="./../../assets/resource/home/banner/jskx2025.jpg"
                />
                <!-- <img
                  class="newfirstlogo"
                  src="./../../assets/resource/home/banner/firstlogo.jpg"
                /> -->
              </div>
            </a>
          </div>
        </el-carousel-item>

        <el-carousel-item>
          <div class="banner2">
            <a target="_blank" href="https://nycre.cn/">
              <div class="common">
                <img
                  class="newBanner"
                  src="./../../assets/resource/home/banner/ycre1920-1.jpg"
                />
              </div>
            </a>
          </div>
        </el-carousel-item>

        <el-carousel-item>
          <div class="banner2">
            <router-link :to="{ path: '/activity2020' }"
              ><img
                class="newBanner"
                src="https://istem-other-files.oss-cn-shanghai.aliyuncs.com/lgb/20241218-1.jpg"
            /></router-link>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="bottom">
        <div class="bottom1">
          <span>{{ $t('Home.text2') }}</span>
          <div>
            <a class="btn1" href="https://cx.istemedu.com">{{
              $t('Home.entry1')
            }}</a>
            <a class="btn2" href="https://class.istemedu.com/childHome">{{
              $t('Home.entry5')
            }}</a>
            <a class="btn2" href="https://class.istemedu.com/vipHome">{{
              $t('Home.entry2')
            }}</a>
            <a class="btn2" href="https://class.istemedu.com/networkCourse">{{
              $t('Home.entry3')
            }}</a>
            <a class="btn2" href="https://class.istemedu.com/tb/home">{{
              $t('Home.entry4')
            }}</a>
          </div>
        </div>
      </div>
    </header>
    <article>
      <section id="about-us">
        <div class="title-part">
          <span class="title">{{ $t('Home.title1') }}</span>
          <div class="title-name">
            <div class="title-text" v-html="$t('Home.text4')"></div>
          </div>
        </div>
        <div class="video-part">
          <div v-if="!videoLoaded" class="video-placeholder" @click="loadVideo">
            <img src="./../../assets/resource/home/prever.png" alt="视频封面" />
            <div class="play-button">
              <svg width="80" height="80" viewBox="0 0 80 80">
                <circle cx="40" cy="40" r="38" fill="rgba(0,0,0,0.6)" stroke="#fff" stroke-width="2"/>
                <polygon points="32,25 32,55 55,40" fill="#fff"/>
              </svg>
            </div>
          </div>
          <video
            v-else
            poster="./../../assets/resource/home/prever.png"
            src="https://media.istemedu.com/2021.mp4.bak"
            controls="controls"
            autoplay
          >
            您的浏览器不支持 video 标签。
          </video>
        </div>
        <div class="more"><span class="wrapper"></span></div>
      </section>
      <section id="last-news">
        <span class="title">{{ $t('Home.title3') }}</span>
        <ul>
          <li
            v-for="(item, index) in this.message"
            :key="index"
            v-if="index < 7"
          >
            <a :href="item.url">
              <span class="flag"></span>
              <span class="dec">{{ item.name }}</span>
            </a>
          </li>
        </ul>
        <div class="bottomssss">
          <router-link :to="{ path: '/latestNews' }" class="goCommunity">{{
            $t('Home.more')
          }}</router-link>
        </div>
      </section>
      <section id="industry-leaders222">
        <div class="title-part">
          <span class="title">{{ $t('Home.title7') }}</span>
        </div>
        <img src="././../../assets/resource/home/industry-leaders.png" alt="" />
      </section>
      <section id="industry-leaders">
        <div class="title-part">
          <span class="title">{{ $t('Home.leaders') }}</span>
        </div>
        <div class="wrapper" id="courseList">
          <img src="./../../assets/resource/home/rope.png" />
          <ul>
            <li class="course0">
              <span class="course-num">0</span>
              <span class="course-text">{{ $t('Home.14') }}</span>
            </li>
            <li class="course1">
              <span class="course-num">01</span>
              <span class="course-text">{{ $t('Home.15') }}</span>
              <div></div>
              <img src="./../../assets/resource/home/rope-text1.png" />
              <!-- <img src="./../../assets/resource/home/rope-text-bg1.png">
                            <span class="text1">{{$t('Home.17')}} |</span>
                            <span class="text2">{{$t('Home.16')}}</span>  -->
            </li>
            <li class="course2">
              <span class="course-num">02</span>
              <span class="course-text">{{ $t('Home.25') }}</span>
              <div></div>
              <img src="./../../assets/resource/home/rope-text2.png" />
              <!-- <img src="./../../assets/resource/home/rope-text-bg2.png">
                            <span class="text1">{{$t('Home.17')}} |</span>
                            <span class="text2">{{$t('Home.18')}}</span>   -->
            </li>
            <li class="course3">
              <span class="course-num">03</span>
              <span class="course-text">{{ $t('Home.26') }}</span>
              <div></div>
              <img src="./../../assets/resource/home/rope-text3.png" />
              <!-- <img src="./../../assets/resource/home/rope-text-bg3.png">
                            <span class="text1">{{$t('Home.19')}} |</span>
                            <span class="text2">{{$t('Home.21')}}</span>   -->
            </li>
            <li class="course4">
              <span class="course-num">04</span>
              <span class="course-text">{{ $t('Home.27') }}</span>
              <div></div>
              <img src="./../../assets/resource/home/rope-text4.png" />
              <!-- <img src="./../../assets/resource/home/rope-text-bg4.png">
                            <span class="text1">{{$t('Home.19')}} |</span>
                            <span class="text2">{{$t('Home.22')}}</span>   -->
            </li>
            <li class="course5">
              <span class="course-num">05</span>
              <span class="course-text">{{ $t('Home.28') }}</span>
              <div></div>
              <img src="./../../assets/resource/home/rope-text5.png" />
              <!-- <img src="./../../assets/resource/home/rope-text-bg5.png">
                            <span class="text1">{{$t('Home.20')}} |</span>
                            <span class="text2">{{$t('Home.23')}}</span>   -->
            </li>
            <li class="course6">
              <span class="course-num">06</span>
              <span class="course-text">{{ $t('Home.29') }}</span>
              <div></div>
              <img src="./../../assets/resource/home/rope-text6.png" />
              <!-- <img src="./../../assets/resource/home/rope-text-bg6.png">
                            <span class="text1">{{$t('Home.20')}} |</span>
                            <span class="text2">{{$t('Home.24')}}</span>    -->
            </li>
          </ul>
        </div>
        <div class="track">
          <img class="track-bg" src="./../../assets/resource/home/track.png" />
          <transition name="slide-arrow1">
            <img
              v-if="show"
              class="arrow arrow1"
              src="./../../assets/resource/home/arrow1.png"
            />
          </transition>
          <transition name="slide-arrow2">
            <img
              v-if="show"
              class="arrow arrow2"
              src="./../../assets/resource/home/arrow2.png"
            />
          </transition>
          <transition name="slide-arrow3">
            <img
              v-if="show"
              class="arrow arrow3"
              src="./../../assets/resource/home/arrow3.png"
            />
          </transition>
          <transition name="slide-arrow4">
            <img
              v-if="show"
              class="arrow arrow4"
              src="./../../assets/resource/home/arrow4.png"
            />
          </transition>
          <transition name="slide-arrow5">
            <img
              v-if="show"
              class="arrow arrow5"
              src="./../../assets/resource/home/arrow5.png"
            />
          </transition>
          <transition name="slide-arrow6">
            <img
              v-if="show"
              class="arrow arrow6"
              src="./../../assets/resource/home/arrow6.png"
            />
          </transition>
          <transition name="slide-arrow0">
            <img
              v-if="show"
              class="arrow arrow0"
              src="./../../assets/resource/home/arrow1.png"
            />
          </transition>
          <transition name="slide-arrow7">
            <img
              v-if="show"
              class="arrow arrow7"
              src="./../../assets/resource/home/arrow6.png"
            />
          </transition>
        </div>
      </section>
      <section id="dudu-community">
        <div class="title-part">
          <span class="title">{{ $t('Home.title5') }}</span>
        </div>
          <div class="works-grid">
            <div class="work-card" v-for="(work, index) in this.userProgress" :key="`work-${index}`"
              @click="handlePush(work.preview_path)">
              <div class="work-image">
                <img :src="work.preview_image" :alt="work.title" loading="lazy">
                <!-- 相框图层 -->
                <img v-if="work.frameUrl" class="frame-overlay" :src="work.frameUrl" alt="frame">
                <div class="work-overlay">
                  <span class="view-btn">{{ $t('common.view') }}</span>
                </div>
              </div>
              <div class="work-info">
                <h3 class="work-title">{{ work.title || '无标题' }}</h3>
                <div class="work-underline"></div>
                <div class="work-meta">
                  <span class="work-author">{{ work.author && work.author.name || '小畅同学' }}</span>
                </div>
              </div>
            </div>
          </div>
        <div class="bottom">
          <router-link :to="{ path: '/community' }" class="goCommunity">{{
            $t('Home.more')
          }}</router-link>
        </div>
      </section>
    </article>
    <footer>
      <footer-page></footer-page>
    </footer>
  </div>
</template>

<script>
import headTop from '@/components/header/index'
import footerPage from '@/components/footer/index'
import axios from 'axios'
import Typed from 'typed.js'
import headGif from '@/assets/resource/home/headGif.gif'

export default {
  data() {
    return {
      videoLoaded: false,
      userProgress: [],
      message: [],
      show: true,
      screenWidth: document.body.clientWidth,
      typeOptions: {
        strings: [this.$t('Home.text1') + '^1000'],
        typeSpeed: 100,
        fadeOut: true,
        loop: true,
        startDelay: 1000
      },
      headGif
    }
  },
  components: {
    headTop,
    footerPage
  },
  created() {
      const frameList = [
        'https://hillary-other-files.istemedu.com/photo-frame/photo%20-frame1.png',
        'https://hillary-other-files.istemedu.com/photo-frame/photo%20-frame2.png'
      ]

      // 确保至少3个有相框，其余随机
      const addRandomFrame = (list) => {
        const total = list.length
        const mustHaveFrameCount = 3
        const usedIndices = new Set()

        // 保证先随机选出3个必须加相框的索引
        while (usedIndices.size < mustHaveFrameCount) {
          const randomIndex = Math.floor(Math.random() * total)
          usedIndices.add(randomIndex)
        }

        return list.map((item, index) => {
          // 如果是必须加相框的项，强制加
          if (usedIndices.has(index)) {
            const frame = frameList[Math.floor(Math.random() * frameList.length)]
            return { ...item, frameUrl: frame }
          } else {
            // 否则随机决定是否加相框（50% 概率）
            const useFrame = Math.random() < 0.5
            const frame = useFrame
              ? frameList[Math.floor(Math.random() * frameList.length)]
              : null
            return { ...item, frameUrl: frame }
          }
        })
      }
    axios.get('/api/v1/school/gallaries').then(res => {
      this.userProgress = addRandomFrame(res.data.body.splice(0, 4))
    })
    this.$http.get('../../../static/bbb.json').then(
      res => {
        this.message = res.data.aaa.reduce((prev, cur) => {
          if (cur.column === '“畅”谈') {
            if (prev.length <= 3) {
              prev.push(cur)
            }
          } else if (cur.column === '“畅”响') {
            if (prev.length <= 1) {
              prev.push(cur)
            }
          } else if (cur.column === '“畅”达') {
            if (prev.length <= 5) {
              prev.push(cur)
            }
          }
          return prev
        }, [])
        // let dataone = []
        // let datatwo = []
        // let datathre = []
        // res.data.aaa.filter(item => {
        //   if (item.column === '“畅”响') {
        //     dataone.push(item)
        //   } else if (item.column === '“畅”谈') {
        //     datatwo.push(item)
        //   } else {
        //     datathre.push(item)
        //   }
        // })
        // dataone = dataone.splice(0, 2)
        // datatwo = datatwo.splice(0, 2)
        // datathre = datathre.splice(0, 2)
        // this.message = datathre.concat(dataone, datatwo)
      },
      res => {}
    )
    this.$nextTick(() => {
      this.zoomCourse(this.screenWidth)
    })
    this.play()
  },
  watch: {
    screenWidth(val) {
      this.screenWidth = val
      this.zoomCourse(val)
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    this.$nextTick(() => {
      this.Typed = new Typed(this.$refs.headType, this.typeOptions)
    })
  },
  methods: {
    loadVideo() {
      this.videoLoaded = true
    },
    handlePush(router) {
      window.open("https://cx.istemedu.com" + router, "_blank")
    },
    autoPlay() {
      this.show = !this.show
    },
    play() {
      setInterval(this.autoPlay, 500)
    },
    zoomCourse(val) {
      let trackDom = document.querySelector('.track')
      let result = parseFloat(val / 960)
      if (result <= 1) {
        trackDom.style.zoom = result
        // trackDom.style.transform = 'scale(' + result + ')'
        trackDom.style.left = 'calc(50% - 480px)'
      } else {
        trackDom.style.left = '0'
      }

      let courseListDom = document.querySelector('#courseList')
      let result1 = parseFloat(val / 700)
      if (result1 <= 1) {
        courseListDom.style.transform = 'scale(' + result1 + ')'
        courseListDom.style.left = 'calc(50% - 350px)'
      } else {
        courseListDom.style.left = '0'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.works-grid {
  display: grid;
  gap: 1.5rem;
  padding: 1rem;

  grid-template-columns: 1fr;

  @media (min-width: 450px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 960px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 768px) {
    gap: 1rem;
    padding: 1rem 0.5rem;
  }

  @media (max-width: 450px) {
    gap: 0.75rem;
    padding: 0.75rem 0.5rem;
  }

  .work-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 8px 48px rgba(0, 0, 0, 0.15);

      .work-overlay {
        opacity: 1;
      }
    }

    .work-image {
      position: relative;
      width: 100%;
      aspect-ratio: 454 / 337; // 保持原图比例
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
        max-width: 100%;
        display: block;
      }

      .work-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;

        .view-btn {
          padding: 0.75rem 1.5rem;
          background: #409EFF;
          color: white;
          border-radius: 25px;
          font-size: 0.9rem;
          font-weight: 600;
        }
      }
    }

    .work-info {
      padding: 1rem;

      @media (max-width: 450px) {
        padding: 0.75rem;
      }

      .work-title {
        font-size: 1.25rem;
        font-weight: 700;
        color: #2c3e50;

        @media (max-width: 450px) {
          font-size: 1.1rem;
        }
      }

      .work-underline {
        width: 40px;
        height: 3px;
        background-color: #093b6a;
        border-radius: 2px;
        margin: 0.25rem 0 0.8rem 0;
      }

      .work-meta {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
        align-items: center;
        font-size: 0.85rem;

        span {
          border-radius: 15px;
          font-weight: 500;

          &.work-type {
            background: #e1f3d8;
            color: #67c23a;
          }

          &.work-author {
            color: #4f6375;
          }

          &.work-date {
            background: #f0f2f5;
            color: #909399;
          }
        }
      }
    }
  }
}
.frame-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 2;
}
.userProgressfont {
  text-align: center;
  margin-top: -8px;
  color: white;
}
.bottomssss {
  font-size: 24px;
  background: #162d55;
  width: 160px;
  line-height: 45px;
  text-align: center;
  display: block;
  margin-left: 51px;
  border-radius: 10px;
  margin-top: 45px;
  a {
    color: #fff;
  }
}
@media screen and (min-width: 415px) {
  header {
    height: 550px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #fff;
    .top {
      width: 100%;
      background: #edae24;
      height: 340px;
      .wrapper {
        max-width: 1170px;
        margin: 0 auto;
        .header-top {
          width: 100%;
          height: 340px;
          background: #edae24;
          position: relative;
          .left {
            float: left;
            width: 50%;
            height: 100%;
            .logo {
              display: block;
              margin: 0 auto;
              max-width: 100%;
              padding-top: 50px;
            }
          }
          .right {
            float: left;
            width: 50%;
            height: 100%;
            .tvFrame {
              display: block;
              box-sizing: border-box;
              max-height: 122%;
              // margin: 0 auto;
              margin-top: -27px;
              margin-left: 120px;
            }
          }
          div.typeWrapper {
            position: absolute;
            top: 245px;
            left: calc(50% - 362px);
            div.type {
              display: inline;
              font-size: 1.75rem;
              color: #0c2f54;
              line-height: 1.6875rem;
            }
          }
        }
        .header-bottom {
          height: 166px;
        }
      }
    }
    .carouselImg {
      width: 100%;
    }
    .bottom {
      // overflow: -webkit-paged-y;
      height: 100px;
      .bottom1 {
        width: 100%;
        // height: 166px;
        background: #162d55;
        display: inline-block;
        span {
          display: block;
          color: #f6ac1d;
          font-size: 1.24rem;
          line-height: 1.3125rem;
          padding-top: 22px;
          text-align: center;
          border-bottom: 1px solid #f6ac1d;
          margin: 0 auto;
          padding-bottom: 12px;
        }
        div {
          display: flex;
          justify-content: center;
          margin-top: 29px;
          padding-bottom: 26px;
          .btn1 {
            color: #f6ac1d;
            border: 2px solid #f6ac1d;
            padding: 10px 0px;
            border-radius: 12px;
            font-size: 24px;
            width: 160px;
            text-align: center;
            &:hover {
              color: #162d55;
              background: #f6ac1d;
            }
          }
          .btn2 {
            color: #f6ac1d;
            border: 2px solid #f6ac1d;
            padding: 10px 0px;
            border-radius: 12px;
            font-size: 22px;
            margin-left: 30px;
            width: 160px;
            text-align: center;
            &:hover {
              color: #162d55;
              background: #f6ac1d;
            }
          }
        }
      }
    }
    .banner2 {
      height: 100%;
      background-size: 100% 100%;
      position: relative;
      a {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
        .newxxx {
          height: 100%;
          width: 100%;
        }
        .common {
          height: 100%;
          .newlogo {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 5%;
            width: 140px;
            height: 140px;
          }
          .newfirstlogo {
            position: absolute;
            left: 14%;
            // transform: translateX(-50%);
            top: 15%;
            width: 80px;
            height: 80px;
          }
          .newBanner {
            height: 100%;
            width: 100%;
          }
          .box {
            position: absolute;
            left: calc(50% - 200px);
            top: 50%;
            transform: translate(calc(-50% + 200px), -50%);
            span {
              display: none;
            }
          }
          .banner-parts {
            position: absolute;
            bottom: -3px;
            left: calc(50% + 21rem);
          }
        }
      }
    }
  }
  article {
    max-width: 1170px;
    margin: 0 auto;
    #about-us {
      // height: 594px;
      background: #e7e7e7;
      .title-part {
        .title {
          display: block;
          width: 585px;
          font-size: 1.875rem;
          color: #092f55;
          border-bottom: 2px solid #edae24;
          margin: 0 auto;
          text-align: center;
          padding-top: 36px;
          padding-bottom: 13px;
        }
        .title-name {
          width: 585px;
          margin-top: 26px;
          color: #092f55;
          word-wrap: break-word;
          word-break: break-all;
          display: block;
          margin: 26px auto;
          // margin-bottom: 0px;
          .title-text {
            display: inline-block;
            // letter-spacing:6px;
            line-height: 30px;
            width: 585px;
            // text-align: center;
            color: #595757;
          }
        }
        .title-text2 {
          width: 669px;
          color: #595757;
          word-wrap: break-word;
          word-break: break-all;
          display: block;
          margin: 26px auto;
          margin-top: 2px;
        }
      }
      .video-part {
        width: 587px;
        height: 326px;
        margin: 0 auto;
        display: block;
        position: relative;
        video {
          height: 100%;
        }
        .video-placeholder {
          width: 100%;
          height: 100%;
          position: relative;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease;
            &:hover {
              transform: translate(-50%, -50%) scale(1.1);
            }
          }
        }
      }
      .more {
        width: 100%;
        padding-bottom: 30px;
        .wrapper {
          display: block;
          font-size: 0.6rem;
          background: #f6ac1d;
          width: 100px;
          line-height: 19px;
          text-align: center;
          margin: 30px auto;
          margin-bottom: 0px;
          border-radius: 10px;
        }
      }
    }
    #last-news {
      max-width: 1170px;
      height: 439px;
      background: url(./../../assets/resource/home/news-bg.png) no-repeat bottom
        center;
      .title {
        font-size: 30px;
        margin-left: 49px;
        padding-top: 42px;
        display: block;
        color: #092f55;
      }
      ul {
        margin-top: 38px;
        li {
          margin-bottom: 10px;
          .flag {
            width: 0px;
            height: 0px;
            background: #fff;
            display: inline-block;
            margin-left: 51px;
            border-width: 8px 0px 8px 8px;
            border-style: solid;
            border-color: #eeae25 transparent;
          }
          .dec {
            color: #fff;
            width: 424px;
            margin-left: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            vertical-align: text-bottom;
            &:hover {
              color: #092f55;
              font-weight: 500;
              font-size: 1.1rem;
            }
          }
        }
      }
      .bottom {
        padding-bottom: 20px;
        .goCommunity {
          font-size: 2rem;
          background: #162d55;
          color: #fff;
          width: 100px;
          line-height: 30px;
          text-align: center;
          display: block;
          margin-left: 51px;
          border-radius: 10px;
          margin-top: 45px;
        }
      }
    }
    #industry-leaders {
      .title-part {
        .title {
          display: block;
          width: 585px;
          font-size: 1.875rem;
          color: #092f55;
          border-bottom: 2px solid #edae24;
          margin: 0 auto;
          text-align: center;
          padding-top: 36px;
          padding-bottom: 13px;
        }
      }
      .wrapper {
        position: relative;
        height: 230px;
        width: 700px;
        margin: 0 auto;
        margin-top: 60px;
        img {
          width: 672px;
          position: absolute;
          // margin-left: 144px;
        }
        li {
          position: absolute;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          top: -21px;
          box-shadow: 2px 5px 10px #555;
          background-color: #f6ac1d;
          color: #fff;
          .goCourse {
            border-radius: 50%;
            width: 56px;
            height: 56px;
            display: inline-block;
          }
          .course-num {
            margin-top: 6px;
            display: inline-block;
            margin-left: 20px;
            font-weight: 600;
            line-height: 22px;
          }
          .course-text {
            margin-left: 7px;
            font-size: 12px;
            font-weight: 600;
          }
          img {
            margin-left: -41px;
            width: 112px;
            height: 112px;
          }
          div {
            width: 1px;
            height: 59px;
            border: 1px solid #092f55;
            margin-left: 28px;
            margin-top: 18px;
            margin-bottom: 10px;
            &::after {
              content: '';
              position: absolute;
              width: 10%;
              height: 10%;
              border-radius: 50%;
              background-color: #092f55;
              left: 26px;
              top: 122px;
            }
            &::before {
              content: '';
              position: absolute;
              width: 10%;
              height: 10%;
              background-color: #092f55;
              left: 26px;
              top: 63px;
              border-radius: 50%;
            }
          }
          .text1 {
            position: absolute;
            top: 150px;
            font-size: 10px;
            left: -4px;
            color: #666;
            font-weight: 500;
          }
          .text2 {
            position: absolute;
            top: 170px;
            font-size: 10px;
            width: 72px;
            left: -4px;
            color: #666;
            line-height: 16px;
            font-weight: 500;
          }
        }
        .course0 {
          left: 20px;
          .course-num {
            margin-left: 24px;
            line-height: 22px;
          }
          .course-text {
            margin-left: 11px;
          }
          z-index: 7;
        }
        .course1 {
          left: 110px;
          z-index: 6;
        }
        .course2 {
          left: 206px;
          z-index: 5;
        }
        .course3 {
          left: 302px;
          z-index: 4;
        }
        .course4 {
          left: 398px;
          z-index: 3;
        }
        .course5 {
          left: 494px;
          z-index: 2;
        }
        .course6 {
          left: 590px;
          z-index: 1;
        }
      }
      .track {
        position: relative;
        width: 960px;
        margin: 0 auto;
        .track-bg {
          width: 960px;
          // margin-top: 230px;
        }
        .arrow {
          position: absolute;
          width: 20px;
          &.arrow1 {
            top: 322px;
            left: 263px;
          }
          &.arrow2 {
            top: 255px;
            left: 263px;
          }
          &.arrow3 {
            top: 188px;
            left: 240px;
          }
          &.arrow4 {
            top: 162px;
            left: 376px;
          }
          &.arrow5 {
            top: 176px;
            left: 500px;
          }
          &.arrow6 {
            top: 180px;
            left: 653px;
          }
          &.arrow0 {
            top: 358px;
            left: 80px;
          }
          &.arrow7 {
            top: 143px;
            left: 825px;
          }
        }
      }
    }
    #industry-leaders222 {
      background: #e6e7e7;
      .title-part {
        .title {
          display: block;
          width: 585px;
          font-size: 1.875rem;
          color: #092f55;
          border-bottom: 2px solid #edae24;
          margin: 0 auto;
          text-align: center;
          padding-top: 36px;
          padding-bottom: 13px;
        }
      }
      img {
        max-width: 90%;
        margin: 31px auto;
        display: block;
        margin-bottom: 0;
      }
    }
    #dudu-community {
      max-width: 1170px;
      height: auto;
      background: url(./../../assets/resource/home/community-bg.png) no-repeat;
      background-size: 100% 100%;
      .title-part {
        border-bottom: 2px solid #fff;
        .title {
          display: block;
          padding: 29px 0 20px 50px;
          font-size: 1.875rem;
          color: #fff;
        }
      }
      .lists {
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          margin-left: 21px;
          margin-top: 40px;
          li {
            width: 260px;
            height: 210px;
            box-sizing: border-box;
            border-top: 20px solid #f1c118;
            border-bottom: 20px solid #f1c118;
            background: #fff;
            margin-right: 20px;
            margin-bottom: 60px;
            position: relative;
            //edit by wuxianbiao
            // flex: 1;
            .fa-2x {
              position: absolute;
              top: -24px;
              left: 13px;
            }
            .fa-1x {
              display: none;
            }
            img {
              width: 210px;
              height: 145px;
              margin: 14px 20px;
              object-fit: cover;
              object-position: right 0px bottom 0px;
              // edit by wuxianbiao
            }
            span {
              color: #fff;
              margin-top: 20px;
              display: inline-block;
            }
            a {
              position: absolute;
              height: 210px;
              width: 250px;
              top: -20px;
              left: 0px;
            }
          }
        }
      }
      .bottom {
        padding-bottom: 20px;
        .goCommunity {
          font-size: 1.1rem;
          background: #f6ac1d;
          width: 100px;
          line-height: 30px;
          text-align: center;
          display: block;
          margin: 0 auto;
          border-radius: 10px;
          // edit by wuxianbiao
          margin-top: 8px;
          margin-bottom: 5px;
        }
      }
    }
  }
  .slide-arrow1-leave-active,
  .slide-arrow2-leave-active,
  .slide-arrow3-leave-active,
  .slide-arrow4-leave-active,
  .slide-arrow5-leave-active,
  .slide-arrow6-leave-active,
  .slide-arrow0-leave-active,
  .slide-arrow7-leave-active {
    transition: all 0.5s ease;
  }
  .slide-arrow1-leave-to {
    transform: translate(60px, -20px);
    opacity: 0;
  }
  .slide-arrow2-leave-to {
    transform: translate(-80px, -38px);
    opacity: 0;
  }
  .slide-arrow3-leave-to {
    transform: translate(50px, -10px);
    opacity: 0;
  }
  .slide-arrow4-leave-to {
    transform: translate(45px, -9px);
    opacity: 0;
  }
  .slide-arrow5-leave-to {
    transform: translate(60px, 15px);
    opacity: 0;
  }
  .slide-arrow6-leave-to {
    transform: translate(60px, -12px);
    opacity: 0;
  }
  .slide-arrow0-leave-to {
    transform: translate(80px, -17px);
    opacity: 0;
  }
  .slide-arrow7-leave-to {
    transform: translate(130px, -30px);
    opacity: 0;
  }
}
@media screen and (max-width: 415px) {
  div.typeWrapper {
    position: absolute;
    top: 155px;
    left: calc(50% - 176px);
    div.type {
      display: inline;
      font-size: 0.8rem;
      color: #0c2f54;
      line-height: 1.6875rem;
    }
  }

  header {
    height: auto;
    margin-top: 0px;
    background: #edae24;
    .top {
      width: 100%;
      background: #edae24;
      height: 210px;
      .header-top {
        width: 100%;
        height: 210px;
        background: #edae24;
        position: relative;
        .left {
          float: left;
          width: 50%;
          height: 100%;
          .logo {
            display: block;
            margin: 0 auto;
            max-width: 100%;
            padding-top: 50px;
          }
        }
        .right {
          float: left;
          width: 50%;
          height: 100%;
          position: relative;
          .tvFrame {
            display: block;
            width: 180px;
            position: absolute;
            bottom: 0px;
            left: calc(50% - 90px);
          }
        }
        .showGif-box {
          position: relative;
          height: 100px;
          width: 100px;
          padding: 10px;
          -webkit-perspective: 885;
          margin-left: calc(75% - 134px);
          padding-top: 67px;
          .showGif-wrapper {
            position: absolute;
            height: 112px;
            width: 240px;
            -webkit-transform: rotateY(298deg) rotateX(37deg) rotateZ(-16deg);
            transform: rotateY(291deg) rotateX(29deg) rotateZ(-13deg);
            .showGif {
              width: 100%;
              height: 100%;
            }
          }
        }
        span {
          position: absolute;
          top: 150px;
          font-size: 15px;
          left: calc(50% - 180px);
          bottom: 16px;
          color: #0c2f54;
          line-height: 1.6875rem;
        }
      }
    }
    .bottom {
      // overflow: -webkit-paged-y;
      .bottom1 {
        width: 100%;
        // height: 166px;
        background: #162d55;
        display: inline-block;
        span {
          display: block;
          color: #f6ac1d;
          /* font-size: 1.24rem; */
          line-height: 1.3125rem;
          padding-top: 22px;
          text-align: center;
          border-bottom: 1px solid #f6ac1d;
          /* width: 819px; */
          margin: 0 auto;
          padding-bottom: 12px;
        }
        div {
          display: flex;
          justify-content: center;
          padding-bottom: 26px;
          .btn1 {
            color: #f6ac1d;
            border: 2px solid #f6ac1d;
            padding: 10px 24px;
            border-radius: 12px;
            margin-top: 29px;
          }
          .btn2 {
            color: #f6ac1d;
            border: 2px solid #f6ac1d;
            padding: 10px 22px;
            border-radius: 12px;
            margin-top: 29px;
            margin-left: 10px;
          }
        }
      }
    }
    .banner2 {
      height: 210px;
      background-size: 100% 100%;
      position: relative;
      a {
        width: 100%;
        height: 100%;

        .newxxx {
          height: 100%;
          width: 100%;
        }
        .common {
          height: 100%;
          .newfirstlogo {
            position: absolute;
            left: 8%;
            top: 15%;
            width: 40px;
            height: 40px;
          }
          .newlogo {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 5%;
            width: 80px;
            height: 80px;
          }
          .newBanner {
            height: 100%;
            width: 100%;
          }
          .box {
            position: absolute;
            left: calc(50% - 200px);
            top: 50%;
            transform: translate(calc(-50% + 200px), -50%);
            span {
              display: none;
            }
          }
          .banner-parts {
            position: absolute;
            bottom: -3px;
            left: calc(50% + 21rem);
          }
        }
      }
    }
  }
  article {
    #about-us {
      background: #e7e7e7;
      .title-part {
        .title {
          display: block;
          font-size: 1.875rem;
          color: #092f55;
          border-bottom: 2px solid #edae24;
          margin: 0 auto;
          text-align: center;
          padding-top: 36px;
          padding-bottom: 13px;
        }
        .title-name {
          margin-top: 26px;
          color: #092f55;
          word-wrap: break-word;
          word-break: break-all;
          display: block;
          margin: 26px auto;
          padding: 0px 8px;
          // margin-bottom: 0px;
          .title-text {
            color: #595757;
          }
        }
        .title-text2 {
          color: #595757;
          word-wrap: break-word;
          word-break: break-all;
          display: block;
          margin: 26px auto;
          margin-top: 2px;
          padding: 0px 8px;
        }
      }
      .video-part {
        display: block;
        position: relative;
        video {
          width: 100%;
        }
        .video-placeholder {
          width: 100%;
          height: 100%;
          position: relative;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease;
            &:hover {
              transform: translate(-50%, -50%) scale(1.1);
            }
          }
        }
      }
      .more {
        width: 100%;
        padding-bottom: 30px;
        .wrapper {
          display: block;
          font-size: 0.6rem;
          background: #f6ac1d;
          width: 81px;
          line-height: 19px;
          text-align: center;
          margin: 30px auto;
          margin-bottom: 0;
          border-radius: 10px;
        }
      }
    }
    #last-news {
      background: url(./../../assets/resource/home/news-bg.png) no-repeat bottom
        center;
      .title {
        font-size: 30px;
        margin-left: 10px;
        padding-top: 20px;
        display: block;
        color: #092f55;
      }
      ul {
        padding-top: 20px;
        padding-bottom: 30px;
        li {
          margin-bottom: 10px;
          .flag {
            width: 0px;
            height: 0px;
            background: #fff;
            display: inline-block;
            margin-left: 10px;
            border-width: 8px 0px 8px 8px;
            border-style: solid;
            border-color: #eeae25 transparent;
          }
          .dec {
            color: #fff;
            width: calc(100% - 40px);
            margin-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            vertical-align: text-bottom;
          }
        }
      }
      .bottom {
        padding-bottom: 20px;
        .goCommunity {
          font-size: 0.6rem;
          background: #162d55;
          color: #fff;
          width: 100px;
          line-height: 19px;
          text-align: center;
          display: block;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
    }
    #industry-leaders {
      .title-part {
        .title {
          display: block;
          font-size: 1.875rem;
          color: #092f55;
          border-bottom: 2px solid #edae24;
          margin: 0 auto;
          text-align: center;
          padding-top: 36px;
          padding-bottom: 13px;
        }
      }
      .wrapper {
        position: relative;
        height: 230px;
        width: 700px;
        margin: 0 auto;
        margin-top: 60px;
        img {
          width: 672px;
          position: absolute;
          // margin-left: 144px;
        }
        li {
          position: absolute;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          top: -21px;
          box-shadow: 2px 5px 10px #555;
          background-color: #f6ac1d;
          color: #fff;
          .goCourse {
            border-radius: 50%;
            width: 56px;
            height: 56px;
            display: inline-block;
          }
          .course-num {
            margin-top: 6px;
            display: inline-block;
            margin-left: 20px;
            font-weight: 600;
            line-height: 22px;
          }
          .course-text {
            margin-left: 7px;
            font-size: 12px;
            font-weight: 600;
          }
          img {
            margin-left: -41px;
            width: 112px;
            height: 112px;
          }
          div {
            width: 1px;
            height: 59px;
            border: 1px solid green;
            margin-left: 28px;
            margin-top: 18px;
            margin-bottom: 10px;
            &::after {
              content: '';
              position: absolute;
              width: 10%;
              height: 10%;
              border-radius: 50%;
              background-color: green;
              left: 26px;
              top: 122px;
            }
            &::before {
              content: '';
              position: absolute;
              width: 10%;
              height: 10%;
              background-color: green;
              left: 26px;
              top: 63px;
              border-radius: 50%;
            }
          }
          .text1 {
            position: absolute;
            top: 150px;
            font-size: 10px;
            left: -4px;
            color: #666;
            font-weight: 500;
          }
          .text2 {
            position: absolute;
            top: 170px;
            font-size: 10px;
            width: 72px;
            left: -4px;
            color: #666;
            line-height: 16px;
            font-weight: 500;
          }
        }
        .course0 {
          left: 20px;
          .course-num {
            margin-left: 24px;
            line-height: 22px;
          }
          .course-text {
            margin-left: 11px;
          }
          z-index: 7;
        }
        .course1 {
          left: 110px;
          z-index: 6;
        }
        .course2 {
          left: 206px;
          z-index: 5;
        }
        .course3 {
          left: 302px;
          z-index: 4;
        }
        .course4 {
          left: 398px;
          z-index: 3;
        }
        .course5 {
          left: 494px;
          z-index: 2;
        }
        .course6 {
          left: 590px;
          z-index: 1;
        }
      }
      .track {
        position: relative;
        width: 960px;
        margin: 0 auto;
        .track-bg {
          width: 960px;
          // margin-top: 230px;
        }
        .arrow {
          position: absolute;
          width: 20px;
          &.arrow1 {
            top: 322px;
            left: 263px;
          }
          &.arrow2 {
            top: 255px;
            left: 263px;
          }
          &.arrow3 {
            top: 188px;
            left: 240px;
          }
          &.arrow4 {
            top: 162px;
            left: 376px;
          }
          &.arrow5 {
            top: 176px;
            left: 500px;
          }
          &.arrow6 {
            top: 180px;
            left: 653px;
          }
          &.arrow0 {
            top: 358px;
            left: 80px;
          }
          &.arrow7 {
            top: 153px;
            left: 825px;
          }
        }
      }
    }
    #industry-leaders222 {
      background: #e6e7e7;
      .title-part {
        .title {
          display: block;
          font-size: 1.875rem;
          color: #092f55;
          border-bottom: 2px solid #edae24;
          margin: 0 auto;
          text-align: center;
          padding-top: 36px;
          padding-bottom: 13px;
        }
      }
      img {
        max-width: 90%;
        margin: 31px auto;
        display: block;
        margin-bottom: 0;
      }
    }
    #dudu-community {
      height: auto;
      background: url(./../../assets/resource/home/community-bg.png) no-repeat;
      background-size: 100% 100%;
      .title-part {
        border-bottom: 2px solid #fff;
        .title {
          display: block;
          padding: 20px 0 20px 10px;
          font-size: 1.875rem;
          color: #fff;
        }
      }
      .lists {
        ul {
          display: flex;
          justify-content: space-evenly;
          flex-wrap: wrap;
          margin: 30px 0 24px 10px;
          li {
            width: 125px;
            height: 105px;
            box-sizing: border-box;
            border-top: 10px solid #f1c118;
            border-bottom: 10px solid #f1c118;
            background: #fff;
            margin-right: 10px;
            margin-bottom: 30px;
            position: relative;
            .fa-1x {
              position: absolute;
              top: -13px;
              left: 10px;
            }
            .fa-2x {
              display: none;
            }
            img {
              width: 105px;
              height: 72px;
              margin: 7px 10px;
              object-fit: cover;
              object-position: right 0px bottom 0px;
            }
            span {
              color: #fff;
              margin-top: 10px;
              display: inline-block;
            }
            a {
              position: absolute;
              height: 105px;
              width: 125px;
              top: -10px;
              left: 0px;
            }
          }
        }
      }
      .bottom {
        padding-bottom: 20px;
        .goCommunity {
          font-size: 0.6rem;
          background: #f6ac1d;
          width: 100px;
          line-height: 19px;
          text-align: center;
          display: block;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
    }
  }
  .slide-arrow1-leave-active,
  .slide-arrow2-leave-active,
  .slide-arrow3-leave-active,
  .slide-arrow4-leave-active,
  .slide-arrow5-leave-active,
  .slide-arrow6-leave-active,
  .slide-arrow0-leave-active,
  .slide-arrow7-leave-active {
    transition: all 0.5s ease;
  }
  .slide-arrow1-leave-to {
    transform: translate(60px, -20px);
    opacity: 0;
  }
  .slide-arrow2-leave-to {
    transform: translate(-80px, -38px);
    opacity: 0;
  }
  .slide-arrow3-leave-to {
    transform: translate(50px, -10px);
    opacity: 0;
  }
  .slide-arrow4-leave-to {
    transform: translate(45px, -9px);
    opacity: 0;
  }
  .slide-arrow5-leave-to {
    transform: translate(60px, 15px);
    opacity: 0;
  }
  .slide-arrow6-leave-to {
    transform: translate(60px, -12px);
    opacity: 0;
  }
  .slide-arrow0-leave-to {
    transform: translate(80px, -17px);
    opacity: 0;
  }
  .slide-arrow7-leave-to {
    transform: translate(130px, -30px);
    opacity: 0;
  }
}

@media screen and (min-width: 415px) and (max-width: 769px) {
  header {
    .right {
      float: left;
      width: 50%;
      height: 100%;
      position: relative;
      .tvFrame {
        width: 300px;
        position: absolute;
        bottom: 0px;
        left: calc(50% - 250px);
      }
    }
    .showGif-box {
      position: relative;
      height: 200px;
      width: 200px;
      padding: 10px;
      -webkit-perspective: 985;
      margin-left: calc(75% - 171px);
      padding-top: 93px;
      .showGif-wrapper {
        position: absolute;
        height: 200px;
        width: 310px;
        -webkit-transform: rotateY(298deg) rotateX(37deg) rotateZ(-16deg);
        transform: rotateY(300deg) rotateX(37deg) rotateZ(-17deg);
        .showGif {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (min-width: 769px) {
  header {
    .right {
      float: left;
      width: 50%;
      height: 100%;
      position: relative;
      .tvFrame {
        display: block;
        box-sizing: border-box;
        max-height: 100%;
        margin: 0 auto;
      }
    }
    .showGif-box {
      position: relative;
      height: 200px;
      width: 200px;
      padding: 10px;
      -webkit-perspective: 985;
      margin-left: calc(75% - 215px);
      padding-top: 29px;
      .showGif-wrapper {
        position: absolute;
        height: 253px;
        width: 386px;
        transform: rotateY(298deg) rotateX(37deg) rotateZ(-16deg);
        .showGif {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue